module.exports = __webpack_public_path__ + "img/adri-krisztian.61cacf82.jpg";